import { Component } from '@angular/core';

@Component({
  selector: 'app-other-valuations',
  templateUrl: './other-valuations.component.html',
  styleUrls: ['./other-valuations.component.css']
})
export class OtherValuationsComponent {

}
